// structure
export const FETCH_CITIZEN_COUNT_INIT = "CITIZEN_COUNT@FETCH_CITIZEN_COUNT_INIT"
export const FETCH_CITIZEN_COUNT_SUCCEDED = "CITIZEN_COUNT@FETCH_CITIZEN_COUNT_SUCCEDED"
export const FETCH_CITIZEN_COUNT_FAILED = "CITIZEN_COUNT@FETCH_CITIZEN_COUNT_FAILED"
